import { ApolloError } from "@apollo/client";
import { ErrorResponse } from "@apollo/client/link/error";
import { GraphQLError } from "graphql";

export const isGraphQLErrorWithCode = (error: ApolloError | ErrorResponse, code: string) => {
  return error?.graphQLErrors?.some((e: GraphQLError) => e?.extensions?.code === code);
};

export const getGraphQLErrorExtensions = (
  error: ApolloError | ErrorResponse,
  code: string,
): Record<string, unknown> | undefined => {
  const match = error?.graphQLErrors?.find((e: GraphQLError) => e?.extensions?.code === code);
  return match?.extensions as Record<string, unknown> | undefined;
};
